// extracted by mini-css-extract-plugin
export default {"operateBtns":"operateBtns--Ehq8U"};